/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Nav_Get_StartedInputs */

const en_common_nav_get_started = /** @type {(inputs: Common_Nav_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Started`)
};

/**
* | output |
* | --- |
* | "Get Started" |
*
* @param {Common_Nav_Get_StartedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_nav_get_started = /** @type {((inputs?: Common_Nav_Get_StartedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Nav_Get_StartedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_nav_get_started(inputs)
});
export { common_nav_get_started as "common.nav.get_started" }